import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { QualityControlCheckType } from "@enums/qualityControlCheckType.enum";
import { environment } from "@environments/environment";
import { CheckGroupPermissions } from "@helpers/checkGroupPermissions";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { CreateQLoopDto } from "@interfaces/createQLoopDto.interface";
import { ChangeWorkOrderCurrentStage } from "@interfaces/dto/changeWorkOrderCurrentStage.interface";
import { ChangeWorkOrderQuantity } from "@interfaces/dto/changeWorkOrderQuantity.interface";
import { ChangeWorkOrderStageDesiredStartTime } from "@interfaces/dto/changeWorkOrderStageDesiredStartTime.interface";
import { ChangeWorkOrderStageEstimatedStartDate } from "@interfaces/dto/changeWorkOrderStageEstimatedStartDate.interface";
import { ChangeWorkOrderStageMachine } from "@interfaces/dto/changeWorkOrderStageMachine.interface";
import { ChangeWorkOrderStageOperator } from "@interfaces/dto/changeWorkOrderStageOperator.interface";
import { ChangeWorkOrderStagePriority } from "@interfaces/dto/changeWorkOrderStagePriority.interface";
import { ChangeWorkOrderStageQuantity } from "@interfaces/dto/changeWorkOrderStageQuantity.interface";
import { CreateOutsideProcessContractMovementForWorkOrderStageDto } from "@interfaces/dto/createOutsideProcessContractMovementForWorkOrderStageDto.interface";
import { ResolveQuarantineDto } from "@interfaces/dto/resolveQuarantineDto.interface";
import { Part } from "@interfaces/models/part.interface";
import { QuarantinedPart } from "@interfaces/models/quarantinedPart.interface";
import { WorkOrderStage } from "@interfaces/models/workOrderStage.interface";
import { PartFileLink } from "@interfaces/partFileLink.interface";
import { PartPurchasableItemRequired } from "@interfaces/partPurchasableItemRequired.interface";
import { PurchasableItem } from "@interfaces/purchasableItem.interface";
import { SalesOrder } from "@interfaces/salesOrder.interface";
import { SalesOrderPart } from "@interfaces/salesOrderPart.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { WorkOrder } from "@interfaces/workOrder.interface";
import { WorkOrderStageIncrementQuantity } from "@interfaces/workOrderStageIncrementQuantity.interface";
import { AllocationWorkOrderService } from "@services/allocationWorkOrder.service";
import { AppSettingsService } from "@services/appSettings.service";
import { FileService } from "@services/file.service";
import { MachineService } from "@services/machine.service";
import { OpsActionAuditService } from "@services/opsActionAudit.service";
import { OutsideProcessContractService } from "@services/outsideProcessContract.service";
import { OutsideProcessContractMovementService } from "@services/outsideProcessContractMovement.service";
import { PartService } from "@services/part.service";
import { PurchasableItemService } from "@services/purchasableItem.service";
import { QuarantinedPartService } from "@services/quarantinedPart.service";
import { SalesOrderService } from "@services/salesOrder.service";
import { SalesOrderPartService } from "@services/salesOrderPart.service";
import { UserProfileService } from "@services/userProfile.service";
import { WorkOrderService } from "@services/workOrder.service";
import { WorkOrderStageService } from "@services/workOrderStage.service";
import { ToastService } from "angular-toastify";
import { Guid } from "guid-typescript";
import { forkJoin } from "rxjs";

@Component({
	moduleId: module.id,
	selector: "workOrders-id",
	styleUrls: ["workOrders-id.css"],
	templateUrl: "workOrders-id.html"
})
export class WorkOrdersIdAdminComponent {
	allocations: any = [];
	childWorkOrders: WorkOrder[] = [];
	consumablesRequired: PartPurchasableItemRequired[] = [];
	createEnabled = false;
	createOutsideProcessDetails: any;
	createOutsideProcessSupplierDropdown: any;
	editEnabled = true;
	fixingsRequired: PartPurchasableItemRequired[] = [];
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	headerTertiaryButtons: AdminHeaderButton[] = [];
	isEnhancedWorkOrderManagement = false;
	isLoading = false;
	isProductionManagement = false;
	isQualityManagement = false;
	isSuperAdmin = false;
	isSupervisor = false;
	item: WorkOrder = new WorkOrder();
	itemId = "";
	itemType = "Work Order";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	machines: any[] = [];
	mode = "view";
	opsActionAudits: any;
	part: Part = new Part();
	people: UserProfile[] = [];
	planPopupCloseButtonOptions: any = { onClick: () => this.closePlanPopup(), text: "Close" };
	planPopupSaveButtonOptions: any = { onClick: () => this.savePlan(), text: "Save Plan" };
	planPopupVisible = false;
	planStages: any[] = [];
	popupAddButtonOptions: any;
	popupAmountQuarantined = 0;
	popupChangeWorkOrderCurrentStage: ChangeWorkOrderCurrentStage = new ChangeWorkOrderCurrentStage();
	popupChangeWorkOrderQuantity: ChangeWorkOrderQuantity = new ChangeWorkOrderQuantity();
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupCreateOutsideProcessContractMovement: CreateOutsideProcessContractMovementForWorkOrderStageDto = new CreateOutsideProcessContractMovementForWorkOrderStageDto();
	popupCreateQLoopDto: CreateQLoopDto = new CreateQLoopDto();
	popupResolveQuarantine: ResolveQuarantineDto = new ResolveQuarantineDto();
	popupSupportingDocument: PartFileLink = new PartFileLink();
	popupTitle = "";
	popupVisible = false;
	popupWorkOrderStageIncrementData: WorkOrderStageIncrementQuantity = new WorkOrderStageIncrementQuantity();
	popupWorkOrderStageReduceQuantityData: ChangeWorkOrderStageQuantity = new ChangeWorkOrderStageQuantity();
	priorities: number[] = Array.from({ length: environment.build.lowestWorkOrderStagePriority }, (_, i) => i + 1);
	purchasableItems: PurchasableItem[] = [];
	qualityControlCheckTypes: any;
	quarantinedParts: QuarantinedPart[] = [];
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	salesOrder: SalesOrder = new SalesOrder;
	salesOrderPart: SalesOrderPart = new SalesOrderPart;
	splitWorkOrders: WorkOrder[] = [];
	stagesWithOutsideContracts: number[] = [];
	statuses: any;
	supportingDocumentButtonOptions = {
		onClick: () => this.addNewSupportingDocumentPopup(),
		text: "Add Document",
		type: "default",
		useSubmitBehavior: false
	}
	supportingDocuments: PartFileLink[] = [];
	title: string = "View " + this.itemType;
	workOrderStages: WorkOrderStage[] = [];

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private allocationWorkOrderService: AllocationWorkOrderService, private appSettingsService: AppSettingsService, private fileService: FileService, private opsActionAuditService: OpsActionAuditService, private outsideProcessContractService: OutsideProcessContractService, private outsideProcessContractMovementService: OutsideProcessContractMovementService, private partService: PartService, private purchasableItemService: PurchasableItemService, private quarantinedPartService: QuarantinedPartService, private salesOrderService: SalesOrderService, private salesOrderPartService: SalesOrderPartService, private userProfileService: UserProfileService, private itemService: WorkOrderService, private machineService: MachineService, private workOrderStageService: WorkOrderStageService) {
		this.qualityControlCheckTypes = GetPropertiesFromEnum(QualityControlCheckType);
		this.isEnhancedWorkOrderManagement = CheckGroupPermissions(appSettingsService, "Enhanced Work Order Management");
		this.isSuperAdmin = CheckGroupPermissions(appSettingsService, "Super Admin");
		this.isSupervisor = CheckGroupPermissions(appSettingsService, "Supervisor");

		this.getMachines();
		this.getPeople();
		this.getPurchasableItems();

		this.route.params
			.subscribe((params) => {
				if (params.id != "create") {
					if (params.id.split("_").length > 1) {
						this.getItem(params.id.split("_")[0], "edit");
						this.edit();
					} else {
						this.getItem(params.id, "view");
					}
				} else {
					this.create();
				}
			});

		this.canSplitWorkOrder = this.canSplitWorkOrder.bind(this);
		this.editChildRow = this.editChildRow.bind(this);
		this.viewChildRow = this.viewChildRow.bind(this);
		this.completeChildWorkOrder = this.completeChildWorkOrder.bind(this);
		this.generateAndDownloadChildMasterLabelPDF = this.generateAndDownloadChildMasterLabelPDF.bind(this);
		this.editSplitRow = this.editSplitRow.bind(this);
		this.viewSplitRow = this.viewSplitRow.bind(this);

		this.addNewOutsideProcessContractMovementPopup = this.addNewOutsideProcessContractMovementPopup.bind(this);
		this.isCreateOutsideProcessMovementAvailable = this.isCreateOutsideProcessMovementAvailable.bind(this);
		this.isReduceWorkOrderStagePopupButtonAvailable = this.isReduceWorkOrderStagePopupButtonAvailable.bind(this);
		this.isResolveAvailableForRow = this.isResolveAvailableForRow.bind(this);

		this.deleteSupportingDocumentLink = this.deleteSupportingDocumentLink.bind(this);
		this.downloadFileLink = this.downloadFileLink.bind(this);
		this.uploadSupportingDocument = this.uploadSupportingDocument.bind(this);

		this.incrementWorkOrderStagePopup = this.incrementWorkOrderStagePopup.bind(this);
		this.reduceWorkOrderStagePopup = this.reduceWorkOrderStagePopup.bind(this);
		this.toggleStagePause = this.toggleStagePause.bind(this);

		this.resolveQuarantinePopup = this.resolveQuarantinePopup.bind(this);
	}

	addNewOutsideProcessContractMovement() {
		this.outsideProcessContractMovementService.createSingle(this.popupCreateOutsideProcessContractMovement).subscribe(
			() => {
				this.toastService.success("Successfully Created Movement");
				this.closePopup();
				this.getAllowedOutsideProcessContractsForWorkOrder(this.item.id, this.mode);
			},
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
	}

	addNewOutsideProcessContractMovementPopup(e: any) {
		const workOrderStageId = e.row.data.id;
		this.outsideProcessContractMovementService.creationDetailsForStage(workOrderStageId).subscribe(
			(res: any) => {
				this.createOutsideProcessDetails = res.response;

				if (this.createOutsideProcessDetails.maximumQuantity < 1) {
					alert("All stock accounted for");
					return false;
				}

				this.popupCreateOutsideProcessContractMovement = new CreateOutsideProcessContractMovementForWorkOrderStageDto();
				this.popupCreateOutsideProcessContractMovement.dateSent = new Date();
				this.popupCreateOutsideProcessContractMovement.outsideProcessContractId = this.createOutsideProcessDetails.outsideProcessContractId;

				this.createOutsideProcessSupplierDropdown = this.createOutsideProcessDetails.suppliers;
				this.popupCreateOutsideProcessContractMovement.quantitySent = this.createOutsideProcessDetails.maximumQuantity;
				this.popupCreateOutsideProcessContractMovement.supplierId = this.createOutsideProcessSupplierDropdown[0].id;
				this.popupCreateOutsideProcessContractMovement.workOrderStageId = workOrderStageId;

				this.popupTitle = "Create Outside Process Movement";
				this.popupVisible = true;
				this.popupAddButtonOptions = { onClick: () => this.addNewOutsideProcessContractMovement(), text: "Create" };
				return false;
			},
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
		return false;
	}

	addNewSupportingDocument() {
		if (this.popupSupportingDocument === null || this.popupSupportingDocument === undefined || this.popupSupportingDocument.fileName === "") {
			alert("Please upload a document");
			return;
		}

		this.supportingDocuments.push(this.popupSupportingDocument);
		this.popupSupportingDocument = new PartFileLink();

		this.updateItem();
		this.closePopup();
	}

	addNewSupportingDocumentPopup() {
		this.popupSupportingDocument = new PartFileLink();
		this.popupTitle = "Add New Supporting Document";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewSupportingDocument(), text: "Add Document" };
	}

	boolYesNo(cellInfo: any) {
		if (cellInfo.value === true) {
			return "YES";
		}
		else {
			return "NO";
		}
	}

	buildButtons(mode: string) {
		this.mode = mode;
		this.headerSecondaryButtons = [];
		this.headerTertiaryButtons = [];
		if (mode == "edit" && this.editEnabled) {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "create" && this.createEnabled) {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" },
				{ icon: "fal fa-calendar-alt", method: "planWorkOrderPopup", text: "Plan" }
			];

			/*if (this.canSplitWorkOrder()) {
				this.headerPrimaryButtons.push({ icon: "fal fa-page-break", method: "splitWorkOrder", text: "Split" });
			}*/

			if (this.canRegenerateWorkOrder()) {
				this.headerPrimaryButtons.push({ icon: "fal fa-sync", method: "regenerateWorkOrder", text: "Regen." });
			}			

			if (this.isSuperAdmin === true) {
				this.headerPrimaryButtons.push({ icon: "fal fa-sync", method: "resetProgress", text: "Reset Progress" });
			}

			this.headerPrimaryButtons.push({ icon: "fal fa-abacus", method: "recalculateEstimates", text: "Ests." });

			if (this.item.workOrderComplete === false) {
				this.headerPrimaryButtons.push({ icon: "fal fa-check-double", method: "completeWorkOrder", text: "Complete" });
			}

			this.headerSecondaryButtons.push({ icon: "fal fa-download", method: "generateAndDownloadPDF", text: "PDF" });
			this.headerSecondaryButtons.push({ icon: "fal fa-download", method: "generateAndDownloadMasterLabelPDF", text: "Mst. Label" });

			this.headerTertiaryButtons.push({ icon: "fal fa-plus", method: "createQLoopPopup", text: "Q-Loop" });

			if (this.isEnhancedWorkOrderManagement === true || this.isSuperAdmin === true || this.isSupervisor === true) {
				this.headerTertiaryButtons.push({ icon: "fal fa-pencil", method: "changeQuantityPopup", text: "Qty." });
			}

			if (this.isEnhancedWorkOrderManagement === true || this.isSuperAdmin === true) {
				this.headerTertiaryButtons.push({ icon: "fal fa-pencil", method: "changeCurrentStagePopup", text: "Cur. Stage" });
			}
		}
		this.headerTertiaryButtons.push({ icon: "fal fa-eye", method: "viewSalesOrder", text: "Sales Order" });
		this.headerTertiaryButtons.push({ icon: "fal fa-eye", method: "viewPart", text: "Part" });
	}

	canRegenerateWorkOrder() {
		if (this.isEnhancedWorkOrderManagement === false && this.isSuperAdmin === false) {
			return false;
		}

		if (this.item.originalWorkOrderId !== undefined && this.item.originalWorkOrderId !== null && this.item.originalWorkOrderId > 0) {
			return false;
		}

		if (this.splitWorkOrders.length > 0) {
			return false;
		}

		const stagesInProgress = this.workOrderStages.filter((workOrderStage) => workOrderStage.quantityCompleted > 0);

		if (stagesInProgress.length > 0) {
			return false;
		}

		return true;
	}

	canSplitWorkOrder() {
		const currentStage = this.workOrderStages.filter((workOrderStage) => workOrderStage.stageNumber === this.item.currentStage);

		if (currentStage === undefined || currentStage === null || currentStage.length === 0) {
			return false;
		}

		return currentStage[0].stageStarted === true && currentStage[0].quantityCompleted < currentStage[0].quantityRequired;
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	changeCurrentStage() {
		if (this.isSuperAdmin === false && this.isEnhancedWorkOrderManagement === false) {
			return;
		}
		this.itemService.changeCurrentStage(this.popupChangeWorkOrderCurrentStage.workOrderId, this.popupChangeWorkOrderCurrentStage.stage).subscribe(
			() => {
				this.toastService.success("Successfully Updated " + this.itemType);
				this.getItem(this.item.id, this.mode);
			},
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
		this.closePopup();
	}

	changeCurrentStagePopup() {
		this.popupChangeWorkOrderCurrentStage = new ChangeWorkOrderCurrentStage();
		this.popupChangeWorkOrderCurrentStage.workOrderId = this.item.id;
		this.popupChangeWorkOrderCurrentStage.stage = this.item.currentStage;
		this.popupTitle = "Change Work Order Current Stage";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.changeCurrentStage(), text: "Change Current Stage" };
	}

	changeQuantity() {
		this.itemService.changeQuantity(this.popupChangeWorkOrderQuantity.workOrderId, this.popupChangeWorkOrderQuantity.quantity).subscribe(
			() => {
				this.toastService.success("Successfully Updated " + this.itemType);
				this.getItem(this.item.id, this.mode);
			},
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
		this.closePopup();
	}

	changeQuantityPopup() {
		this.popupChangeWorkOrderQuantity = new ChangeWorkOrderQuantity();
		this.popupChangeWorkOrderQuantity.workOrderId = this.item.id;
		this.popupChangeWorkOrderQuantity.quantity = this.item.quantity;
		this.popupTitle = "Change Work Order Quantity";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.changeQuantity(), text: "Change Quantity" };
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	closePlanPopup() {
		this.planPopupVisible = false;
	}

	closePopup() {
		this.popupVisible = false;
	}

	completeChildWorkOrder() {
		if (this.item.workOrderComplete === true) {
			alert("Child Work Order is already Complete");
			return;
		}
		if (confirm("Are you sure you wish to mark this child work order as complete? This will complete all stages in this work order, though inspections will still need adding. This cannot be undone.") === false) {
			return;
		}

		// Call the increment endpoint
		this.itemService.complete(this.item.id)
			.subscribe(
				() => {
					this.getItem(this.item.id, this.mode);
					this.toastService.success("Successfully Completed Work Order");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	completeWorkOrder() {
		if (this.item.workOrderComplete === true) {
			alert("Work Order is already Complete");
			return;
		}
		if (confirm("Are you sure you wish to mark this work order as complete? This will complete all stages in this work order, though inspections will still need adding. This cannot be undone.") === false) {
			return;
		}

		// Call the increment endpoint
		this.itemService.complete(this.item.id)
			.subscribe(
				() => {
					this.getItem(this.item.id, this.mode);
					this.toastService.success("Successfully Completed Work Order");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated " + this.itemType);
					this.item.supportingDocuments = JSON.stringify(this.supportingDocuments);
					this.item = new WorkOrder();
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	createQLoop() {
		this.itemService.createQLoop(this.popupCreateQLoopDto).subscribe(
			(res: any) => {
				this.toastService.success("Successfully Created Q-Loop");
				const newWorkOrderResponse = res.response;
				this.itemService.getSingleByLookupId(newWorkOrderResponse.lookupId).subscribe(
					(res: any) => {
						const newWorkOrder = res.response;
						this.router.navigate([`${this.itemUrl}/${newWorkOrder.id}`]);
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					}
				);
			},
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
		this.closePopup();
	}

	createQLoopPopup() {
		this.popupCreateQLoopDto = new CreateQLoopDto();
		this.popupCreateQLoopDto.workOrderId = this.item.id;
		this.popupCreateQLoopDto.quantity = this.item.quantity;
		this.popupCreateQLoopDto.dateRequired = this.item.dateRequired;
		this.popupTitle = "Create Q-Loop";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.createQLoop(), text: "Create Q-Loop" };
	}

	deleteSupportingDocumentLink(e: any) {
		if (confirm("Are you sure you wish to delete this document? This will save any outstanding changes to the work order.") == false) {
			return;
		}

		const index = this.supportingDocuments.findIndex(d => d.version === e.row.data.version);
		this.supportingDocuments.splice(index, 1);

		this.updateItem();

		return false;
	}

	displayMachineInPlan = (e: any) => {
		if (!e) return null;
		const name = e.name ?? e.machineName ?? "";
		return e.cellNumber ? `${e.cellNumber} - ${name}` : name;
	}

	downloadFileLink(e: any) {
		const lookupId = Guid.parse(e.row.data.lookupId);
		this.fileService.downloadFile(lookupId).subscribe(
			(response: any) => {
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
				downloadLink.setAttribute("download", e.row.data.fileName);
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
		return false;
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	editChildRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]);
	}

	editSplitRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]);
	}

	generateAndDownloadChildMasterLabelPDF(e: any) {
		this.itemService.generateAndDownloadMasterLabelPdf(e.row.data.id).subscribe(
			(response: any) => {
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
				downloadLink.setAttribute("download", "Work_Order_Master_Label_" + e.row.data.id + ".pdf");
				document.body.appendChild(downloadLink);
				downloadLink.click();
			},
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			},
		);
	}

	generateAndDownloadMasterLabelPDF() {
		this.itemService.generateAndDownloadMasterLabelPdf(this.item.id).subscribe(
			(response: any) => {
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
				downloadLink.setAttribute("download", "Work_Order_Master_Label_" + this.item.id + ".pdf");
				document.body.appendChild(downloadLink);
				downloadLink.click();
			},
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			},
		);
	}

	generateAndDownloadPDF() {
		this.itemService.generateAndDownloadPdf(this.item.id).subscribe(
			(response: any) => {
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
				downloadLink.setAttribute("download", "Work_Order_" + this.item.id + ".pdf");
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
	}

	getAllocations(workOrderId: number) {
		this.allocationWorkOrderService.forWorkOrder(workOrderId)
			.subscribe(
				(res: any) => {
					this.allocations = res.response;
				},
				(err) => console.log(err)
			);
	}

	getAllowedOutsideProcessContractsForWorkOrder(workOrderId: number, buttonMode: string) {
		this.outsideProcessContractService.getAllowedForWorkOrder(workOrderId)
			.subscribe(
				(res: any) => {
					this.stagesWithOutsideContracts = res.response;
					this.getWorkOrderStages(buttonMode);
				},
				(err) => console.log(err)
			);
	}

	getItem(itemId: number, buttonMode: string) {
		this.itemService.getSingleById(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.supportingDocuments = JSON.parse(this.item.supportingDocuments);
					this.getAllocations(this.item.id);
					this.getSalesOrderPart();
					this.getSplitWorkOrders();
					this.getPart();
					this.getSalesOrder();
					this.getOpsActionAudits(this.item.id);
					this.getAllowedOutsideProcessContractsForWorkOrder(this.item.id, buttonMode);
					this.getQuarantinedParts(this.item.id);
				},
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
	}

	getMachines() {
		this.machineService.getAll()
			.subscribe(
				(res: any) => {
					this.machines = res.response.items;
				},
				(err) => console.log(err)
			);
	}

	getOpsActionAudits(workOrderId: number) {
		this.opsActionAuditService.getByWorkOrderId(workOrderId)
			.subscribe(
				(res: any) => {
					this.opsActionAudits = res.response;
				},
				(err) => console.log(err)
			);
	}

	getPart() {
		this.partService.getSingleById(this.item.partId)
			.subscribe(
				(res: any) => {
					this.part = res.response;
					this.consumablesRequired = JSON.parse(this.part.consumablesRequired);
					if (this.consumablesRequired === null || this.consumablesRequired === undefined) {
						this.consumablesRequired = [];
					}
					this.fixingsRequired = JSON.parse(this.part.fixingsRequired);
					if (this.fixingsRequired === null || this.fixingsRequired === undefined) {
						this.fixingsRequired = [];
					}
				},
				(err) => console.log(err)
			);
	}

	getPeople() {
		this.userProfileService.getActiveUsers()
			.subscribe(
				(res: any) => {
					this.people = res.response;
					this.people.sort((a, b) => a.fullName.localeCompare(b.fullName));
				},
				(err) => console.log(err)
			);
	}

	getPurchasableItems() {
		this.purchasableItemService.getAll()
			.subscribe(
				(res: any) => {
					this.purchasableItems = res.response.items;
					this.purchasableItems.sort((a, b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	getQuarantinedParts(id: number) {
		this.quarantinedPartService.getByWorkOrderId(id)
			.subscribe(
				(res: any) => {
					this.quarantinedParts = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	getSalesOrder() {
		this.salesOrderService.getSingleById(this.item.salesOrderId)
			.subscribe(
				(res: any) => this.salesOrder = res.response,
				(err) => console.log(err)
			);
	}

	getSalesOrderPart() {
		if (this.item.salesOrderPartId == null || this.item.salesOrderPartId == undefined) {
			return;
		}
		this.salesOrderPartService.getSingleById(this.item.salesOrderPartId)
			.subscribe(
				(res: any) => {
					this.salesOrderPart = res.response;
				},
				(err) => console.log(err)
			);
	}

	getSplitWorkOrders() {
		this.itemService.getForOriginal(this.item.id)
			.subscribe(
				(res: any) => {
					this.splitWorkOrders = res.response;
				},
				(err) => console.log(err)
			);
	}

	getWorkOrderStages(buttonMode: string) {
		this.workOrderStageService.getForWorkOrder(this.item.id)
			.subscribe(
				(res: any) => {
					this.workOrderStages = res.response;
					this.buildButtons(buttonMode);
				},
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	incrementWorkOrderStage() {
		if (this.popupWorkOrderStageIncrementData === null || this.popupWorkOrderStageIncrementData === undefined) {
			alert("Something went wrong!");
			return;
		}
		if (this.popupWorkOrderStageIncrementData.quantity > this.popupWorkOrderStageIncrementData.maximumQuantity) {
			alert("Quantity too high");
			return;
		}

		// Call the increment endpoint
		this.workOrderStageService.completedQuantity(this.popupWorkOrderStageIncrementData.id, this.popupWorkOrderStageIncrementData.quantity)
			.subscribe(
				() => {
					this.popupWorkOrderStageIncrementData = new WorkOrderStageIncrementQuantity();
					this.getItem(this.item.id, this.mode);
					this.closePopup();
					this.toastService.success("Successfully Incremented Quantity");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	incrementWorkOrderStagePopup(e: any) {
		this.popupWorkOrderStageIncrementData = new WorkOrderStageIncrementQuantity();
		this.popupWorkOrderStageIncrementData.id = e.row.data.id;
		this.popupWorkOrderStageIncrementData.maximumQuantity = e.row.data.quantityRequired - e.row.data.quantityCompleted;
		this.popupWorkOrderStageIncrementData.quantity = 1;
		this.popupTitle = "Increase Completed Quantity for Stage " + e.row.data.stageNumber;
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.incrementWorkOrderStage(), text: "Increase Completed Quantity" };
	}

	isCreateOutsideProcessMovementAvailable(e: any) {
		const stageNumber = e.row.data.stageNumber;
		const outsideProcessContracts = this.stagesWithOutsideContracts.filter(x => x == stageNumber);
		return outsideProcessContracts.length > 0;
	}

	isIncrementWorkOrderStagePopupButtonAvailable(e: any) {
		return e.row.data.quantityRequired > e.row.data.quantityCompleted;
	}

	isPauseStageButtonAvailable(e: any) {
		return e.row.data.isPaused === false;
	}

	isReduceWorkOrderStagePopupButtonAvailable(e: any) {
		return e.row.data.stageStarted == true && (this.isSuperAdmin === true || this.isSupervisor === true);
	}
	
	isResolveAvailableForRow(e: any) {
		return e.row.data.quarantineResolved === false && (this.isProductionManagement || this.isQualityManagement || this.isSuperAdmin);
	}

	isUnpauseStageButtonAvailable(e: any) {
		return e.row.data.isPaused === true;
	}

	onPlanTimeChange(event: Event, stage: any) {
		const input = event.target as HTMLInputElement;
		stage.estimatedStartTime = input.value !== "" ? +input.value : null;
	}

	planWorkOrderPopup() {
		this.planStages = this.workOrderStages
			.slice()
			.sort((a, b) => a.stageNumber - b.stageNumber)
			.map((stage: any) => ({
				_origEstimatedStartDate: stage.estimatedStartDate ?? null,
				_origEstimatedStartTime: null,
				_origMachineId: stage.machineId ?? null,
				_origPriority: stage.priority ?? null,
				_origUserProfileId: stage.assignedUserProfileId ?? null,
				estimatedStartDate: stage.estimatedStartDate ?? null,
				estimatedStartTime: null,
				id: stage.id,
				isPaused: stage.isPaused ?? false,
				machineId: stage.machineId ?? null,
				priority: stage.priority ?? null,
				processName: stage.process?.name ?? "",
				quantityCompleted: stage.quantityCompleted ?? 0,
				quantityRequired: stage.quantityRequired ?? 0,
				stageNumber: stage.stageNumber,
				userProfileId: stage.assignedUserProfileId ?? null,
			}));
		this.planPopupVisible = true;
	}

	recalculateEstimates() {
		if (confirm("Are you sure you wish to recalculate the estimates on this work order? This will also affect any Linked work orders.") == false) {
			return;
		}
		this.itemService.recalculateEstimates(this.item.lookupId)
			.subscribe(
				() => {
					this.toastService.success("Successfully Recalculated Estimates");
					this.getItem(this.item.id, this.mode);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	reduceWorkOrderStage() {
		// Call the increment endpoint
		this.workOrderStageService.reduceQuantity(this.popupWorkOrderStageReduceQuantityData.workOrderStageId, this.popupWorkOrderStageReduceQuantityData.quantity)
			.subscribe(
				() => {
					this.popupWorkOrderStageReduceQuantityData = new ChangeWorkOrderStageQuantity();
					this.getItem(this.item.id, this.mode);
					this.closePopup();
					this.toastService.success("Successfully Reduced Quantity");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	reduceWorkOrderStagePopup(e: any) {
		this.popupWorkOrderStageReduceQuantityData = new ChangeWorkOrderStageQuantity();
		this.popupWorkOrderStageReduceQuantityData.workOrderStageId = e.row.data.id;
		this.popupWorkOrderStageReduceQuantityData.quantity = e.row.data.completedQuantity;
		this.popupTitle = "Reduce Completed Quantity for Stage " + e.row.data.stageNumber;
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.reduceWorkOrderStage(), text: "Reduce Completed Quantity" };
	}

	regenerateWorkOrder() {
		if (confirm("Are you sure you wish to regenerate the stages on this work order? This will also affect any Linked work orders (and will fail if there is any progress on them).") == false) {
			return;
		}
		this.itemService.regenerate(this.item.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Regenerated");
					this.getWorkOrderStages(this.mode);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	resetProgress() {
		if (confirm("Are you sure you wish to reset progress for this work order? This will zero all quantities completed on all stages belonging to this and linked work orders. Stock Levels will be unaffected. This cannot be undone.") === false) {
			return;
		}

		// Call the reset endpoint
		this.itemService.resetProgress(this.item.id)
			.subscribe(
				() => {
					this.getItem(this.item.id, this.mode);
					this.toastService.success("Successfully Reset Progress on Work Order");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
		
	resolveQuarantine() {
		this.quarantinedPartService.resolve(this.popupResolveQuarantine)
			.subscribe(
				() => {
					this.getQuarantinedParts(this.item.id);
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	resolveQuarantinePopup(e: any) {
		this.popupResolveQuarantine = new ResolveQuarantineDto();
		this.popupResolveQuarantine.quarantinedPartId = e.row.data.id;
		this.popupAmountQuarantined = e.row.data.amountQuarantined;
		this.popupAddButtonOptions = { onClick: () => this.resolveQuarantine(), text: "Resolve" };
		this.popupTitle = "Resolve Quarantine";
		this.popupVisible = true;
	}

	savePlan() {
		const calls: any[] = [];

		for (const stage of this.planStages) {
			if (stage.machineId !== stage._origMachineId) {
				const data = new ChangeWorkOrderStageMachine();
				data.workOrderStageId = stage.id;
				data.machineId = stage.machineId ?? undefined;
				calls.push(this.workOrderStageService.changeMachine(data));
			}

			if (stage.userProfileId !== stage._origUserProfileId) {
				const data = new ChangeWorkOrderStageOperator();
				data.workOrderStageId = stage.id;
				data.userProfileId = stage.userProfileId ?? undefined;
				data.operatorQueue = JSON.stringify([]);
				calls.push(this.workOrderStageService.changeOperator(data));
			}

			if (stage.estimatedStartDate !== stage._origEstimatedStartDate && stage.estimatedStartDate !== null) {
				const data = new ChangeWorkOrderStageEstimatedStartDate();
				data.workOrderStageId = stage.id;
				data.estimatedStartDate = stage.estimatedStartDate;
				calls.push(this.workOrderStageService.changeEstimatedStartDate(data));
			}

			if (stage.estimatedStartTime !== null && stage.estimatedStartTime !== stage._origEstimatedStartTime) {
				const data = new ChangeWorkOrderStageDesiredStartTime();
				data.workOrderStageId = stage.id;
				data.startTime = stage.estimatedStartTime;
				calls.push(this.workOrderStageService.changeDesiredStartTime(data));
			}

			if (stage.priority !== null && stage.priority !== stage._origPriority) {
				const data = new ChangeWorkOrderStagePriority();
				data.workOrderStageId = stage.id;
				data.priority = stage.priority;
				calls.push(this.workOrderStageService.changePriority(data));
			}
		}

		if (calls.length === 0) {
			this.planPopupVisible = false;
			return;
		}

		this.isLoading = true;
		forkJoin(calls).subscribe(
			() => {
				this.isLoading = false;
				this.toastService.success("Plan saved successfully");
				this.getWorkOrderStages(this.mode);
				this.planPopupVisible = false;
			},
			(err) => {
				this.isLoading = false;
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
	}

	splitWorkOrder() {
		if (this.canSplitWorkOrder() === false) {
			alert("This Work Order cannot be split.");
		}
		if (confirm("Are you sure you wish to split this Work Order? This cannot be undone. Child work orders will also be split proportionally.") == false) {
			return;
		}
		this.itemService.split(this.item.id)
			.subscribe(
				() => this.close(),
				(err) => console.log(err)
			);
	}

	toggleStagePause(e: any) {
		this.workOrderStageService.togglePause(e.row.data.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Toggled Pause");
					this.getWorkOrderStages(this.mode);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
		return false;
	}

	updateItem() {
		this.item.supportingDocuments = JSON.stringify(this.supportingDocuments);
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated");
					this.getItem(this.item.id, this.mode);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	uploadSupportingDocument(file: File) {
		const containerName = "workorderfiles";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		// Add Mime Type key when mime types are decided upon...
		// uploadData.append("mimeTypeKey", "CADFileMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.popupSupportingDocument.lookupId = res.response[0].lookupId;
					this.popupSupportingDocument.fileName = res.response[0].name;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Supporting Document Upload Failed - Please ensure you are uploading a valid file");
				}
			);
	}

	viewChildRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]);
	}

	viewPart() {
		this.router.navigate([`admin/parts/${this.item.partId}`]);
	}

	viewSalesOrder() {
		this.router.navigate([`admin/salesOrders/${this.salesOrder.lookupId}`]);
	}

	viewSplitRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]);
	}
}